import React from "react";
import "../styles/sections.css";

const Pricing = ({ translations }) => {
  return (
    <section className="section pricing gradient-background">
      <div className="container">
        <h2>{translations.pricingTitle}</h2>
        <div className="pricing-steps">
          <p>{translations.pricingSteps[0]}</p>
          <p>{translations.pricingSteps[1]}</p>
        </div>
        <div className="pricing-options">
          {translations.pricingPlans.map((plan, index) => (
            <div key={index} className="pricing-plan">
              <h3>{plan.name}</h3>
              <p>{plan.description}</p>
              <p className="price">{plan.price}</p>
              <a href="https://chromewebstore.google.com/detail/v-assistant/dbnkcofhncegnjcnngabfgfhgkbkmboh" 
                target="_blank" 
                rel="noopener noreferrer">
                <button className="button">{translations.pricingButton}</button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;